import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import { compose, withHandlers, withProps } from 'recompose';

export const EditDeleteButtons = ({
  editProps,
  deleteProps,
  url,
  id,
  wrapOnDelete,
  allowDelete,
  readOnly,
}) =>
  readOnly ? (
    <span>
      <Link
        className="btn btn-primary btn-sm mr-1"
        to={`${url}/${id}`}
        {...editProps}
      >
        <span className="fa fa-eye" />
      </Link>
    </span>
  ) : (
    <span>
      <Link
        className="btn btn-primary btn-sm mr-1"
        to={`${url}/${id}`}
        {...editProps}
      >
        <span className="fa fa-edit" />
      </Link>
      {allowDelete && (
        <Button
          color="danger"
          size="sm"
          {...deleteProps}
          onClick={wrapOnDelete}
        >
          <span className="fa fa-trash" />
        </Button>
      )}
    </span>
  );

const enhance = compose(
  withProps(({ onDelete }) => ({
    allowDelete: !!onDelete,
  })),
  withHandlers({
    wrapOnDelete: ({ id, onDelete }) => () => onDelete(id),
  })
);

export default enhance(EditDeleteButtons);



// WEBPACK FOOTER //
// ./src/components/common/Tables/EditDeleteButtons.jsx